module.exports = __webpack_public_path__ + "static/media/sabrina-6.d697f12a.wav";